var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66656 1.33333C2.30142 1.33333 1.99989 1.63486 1.99989 2V10C1.99989 10.3651 2.30142 10.6667 2.66656 10.6667H13.3332C13.6984 10.6667 13.9999 10.3651 13.9999 10V2C13.9999 1.63486 13.6984 1.33333 13.3332 1.33333H2.66656ZM0.666561 2C0.666561 0.898477 1.56504 0 2.66656 0H13.3332C14.4347 0 15.3332 0.898477 15.3332 2V10C15.3332 11.1015 14.4347 12 13.3332 12H2.66656C1.56504 12 0.666561 11.1015 0.666561 10V2Z",
    fill: "#858A97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787073 1.61769C0.998216 1.31606 1.4139 1.2427 1.71554 1.45385L7.99989 5.8529L14.2843 1.45385C14.5859 1.2427 15.0016 1.31606 15.2127 1.61769C15.4239 1.91932 15.3505 2.33501 15.0489 2.54615L8.3822 7.21282C8.15266 7.3735 7.84713 7.3735 7.61759 7.21282L0.95092 2.54615C0.649287 2.33501 0.57593 1.91932 0.787073 1.61769Z",
    fill: "#858A97"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.5c7691da.svg";
export { ForwardRef as ReactComponent };